var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6073 7.24796L15.0787 1.66582C15.0519 1.37653 14.8216 1.14796 14.5323 1.11939L8.95016 0.59082H8.94302C8.88587 0.59082 8.84123 0.608677 8.8073 0.642606L0.4448 9.00511C0.428246 9.02163 0.415112 9.04125 0.406152 9.06285C0.397191 9.08446 0.392578 9.10761 0.392578 9.131C0.392578 9.15439 0.397191 9.17754 0.406152 9.19915C0.415112 9.22075 0.428246 9.24037 0.4448 9.25689L6.94123 15.7533C6.97516 15.7873 7.0198 15.8051 7.06802 15.8051C7.11623 15.8051 7.16087 15.7873 7.1948 15.7533L15.5573 7.39082C15.593 7.35332 15.6109 7.30154 15.6073 7.24796ZM7.06623 13.9605L2.23766 9.13189L9.37516 1.99439L13.7859 2.41225L14.2037 6.82296L7.06623 13.9605ZM11.0002 3.62653C10.1341 3.62653 9.42873 4.33189 9.42873 5.19796C9.42873 6.06404 10.1341 6.76939 11.0002 6.76939C11.8662 6.76939 12.5716 6.06404 12.5716 5.19796C12.5716 4.33189 11.8662 3.62653 11.0002 3.62653ZM11.0002 5.76939C10.6841 5.76939 10.4287 5.51404 10.4287 5.19796C10.4287 4.88189 10.6841 4.62654 11.0002 4.62654C11.3162 4.62654 11.5716 4.88189 11.5716 5.19796C11.5716 5.51404 11.3162 5.76939 11.0002 5.76939Z",
    fill: "#F8F8F8",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.c8986e3483aba16271303019fbddc586.svg";
export { ForwardRef as ReactComponent };